<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <label class="inputLabel">广告主ID：</label>
          <el-input
            v-model="advertisersQuery.account_id"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">广告主名称：</label>
          <el-input
            v-model="advertisersQuery.account_name"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">广告组名称：</label>
          <el-input
            v-model="advertisersQuery.dynamic_creative_name"
            placeholder="请输入内容"
          />
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-refresh"
          @click="handleSearchReset"
        >
          重置
        </el-button>

        <!-- <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-s-help"
          @click="eliminate"
        >
          清除账号
        </el-button> -->
        <!-- <el-button
          icon="el-icon-download"
          class="filter-item"
          type="success"
          @click="pullAll"
        >批量拉取素材报表</el-button> -->
        <!-- <el-button
          icon="el-icon-plus"
          class="filter-item"
          type="warning"
          @click="addadvr"
        >新增</el-button> -->
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between;"
      >
        <el-table-column
          prop="id"
          label="id"
          align="center"
          width="80"
        />
        <el-table-column
          prop="account_name"
          label="广告主名称"
          align="center"
          width="180"
        />
        <el-table-column
          prop="account_id"
          label="广告主id"
          align="center"
          width="180"
        />
        <el-table-column
          prop="configured_status"
          label="系统状态"
          align="center"
          width="180"
        />

        <el-table-column
          prop="delivery_mode_text"
          label="交付方式"
          align="center"
          width="180"
        />
        <el-table-column
          prop="dynamic_creative_name"
          label="动态创意名称"
          align="center"
        />
        <el-table-column
          prop="dynamic_creative_type_text"
          label="动态创意类型"
          align="center"
        />
        <el-table-column
          prop="creative_components"
          label="创意组件"
          align="center"
        >
          <template scope="scope">
            {{ scope.row.action_button }}
          </template></el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
          width="180"
        />
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />

    </el-card>
    <CodeScanning
      ref="codeScanning"
      :title="typeValue === 'QQ' ? 'QQ扫码登录' : typeValue === '微信' ? '微信扫码登录' : typeValue "
      :myobj="mStyle[typeValue] || {}"
      @openedEnd="openedEnd"
      @reset="reset"
    />
    <el-dialog
      title="批量拉取"
      :visible.sync="dialogVisiblePull"
      width="600px"
      :before-close="handleClose"
    >
      <detailsList
        ref="pull"
        @addPull="addPull"
      />
    </el-dialog>
    <el-dialog
      title="广告"
      :visible.sync="dialogVisibleadr"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <addAD
        ref="addadview"
        @updata="updata"
      />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { dynamic_creativeindex, getQrCode, eliminate, change_name, change_app_id, advertisers } from '@/api/customer.js'
import { getURL, getBalance, qqShouQuan, syncNotes, adqShouQuan } from '@/api/report/accountManagement'
import detailsList from '../../customer/accountList/components/details.vue'
import CodeScanning from '../../customer/accountList/codeScanningLogin/index.vue'
import addAD from '../../customer/accountList/tencentAdqAdvertManage/addAD/index.vue'
import axios from 'axios'

const mStyle = {
  QQ: {
    left: '-119px',
    top: '-76px',
    width: '424px'
  },
  微信: {
    left: '-189px',
    top: '-43px',
    width: '568px'
  },
  MP扫码登录: {
    top: '-45px',
    left: '-189px',
    width: '568px'
  },
  同步备注: {
    top: '-100px',
    left: '-189px',
    width: '568px'
  },
  ADQ扫码登录: {
    top: '-139px',
    left: '-341px',
    width: '888px'
  }
}

export default {
  name: 'AccountList',
  components: {
    PaginationRight,
    CodeScanning,
    detailsList,
    addAD
    // AdminAdvertAdd
  },
  filters: {
    // 用于过滤主要运营人员 如果 is_master 为 1 则 relation_name 就是主要运营成员
    filterMaster(currentData) {
      for (let i = 0; i < currentData.length; i++) {
        if (currentData[i].is_master === 1) {
          return currentData[i].relation_name
        }
      }
    }
  },
  data() {
    return {
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      // table列表数据请求参数
      advertisersQuery: {
        dynamic_creative_name: null,
        account_name: null, // 广告主名称
        account_id: null, // 广告组名称
        // type: null,
        page: null, // 当前页码
        page_size: null // 广告在系统中的状态
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      // 账号类型
      accountType: [
        {
          value: 1,
          label: '微信公众号'
        },
        {
          value: 2,
          label: '腾讯广告(adq)'
        }
      ],
      options: [
        {
          label: '腾讯', // 客户系统状态 枚举值
          options: [
            {
              value: 'CUSTOMER_STATUS_NORMAL',
              label: '有效'
            },
            {
              value: 'CUSTOMER_STATUS_PENDING',
              label: '待审核'
            },
            {
              value: 'CUSTOMER_STATUS_DENIED',
              label: '审核不通过'
            },
            {
              value: 'CUSTOMER_STATUS_FROZEN',
              label: '封停'
            },
            {
              value: 'CUSTOMER_STATUS_FROZEN_TEMPORARILY',
              label: '临时冻结'
            }
          ]
        },
        {
          label: '微信', // 微信广告账户授权状态 枚举值
          options: [
            {
              value: 'STATUS_PRE_AUTHORIZATION',
              label: '预授权'
            },
            {
              value: 'STATUS_CONFIRM_AUTHORIZATION',
              label: '确认授权/已绑定'
            },
            {
              value: 'STATUS_REQUEST_CANCELATION',
              label: '请求撤销授权'
            }
          ]
        }
      ],
      accountIdsQuery: [], // 获取用户余额的参数
      loading: false, // 加载动画
      dialogVisible: false,
      dialogVisiblePull: false,
      moneyLoading: false, // 余额加载动画
      mantle: false,
      source: null,
      typeValue: '',
      mStyle: mStyle,
      activeItem: null,
      activeItemId: null,
      activeText: null,
      activeTextid: null,
      dialogVisibleadr: false,
      alone: null
    }
  },
  created() {
    this.getAdvertiserList()
  },
  methods: {

    copy(row) {},
    async addPull(obj) {
      console.log('obj:', obj)
      await advertisers(obj)
      this.$message.success('批量拉取成功')
      this.dialogVisiblePull = false
    },
    handleClose() {
      this.dialogVisiblePull = false
    },
    pullAll() {
      this.dialogVisiblePull = true
      this.$nextTick(() => {
        this.$refs.pull.sendr()
      })
    },
    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await change_name({ id: this.activeItem.id, account_name: this.activeText })
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getAdvertiserList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },
    async blur2() {
      if (this.activeItemId.consume !== this.activeTextid) {
        try {
          await change_app_id({ id: this.activeItemId.id, app_id: this.activeTextid })
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getAdvertiserList()
        } catch (err) {
          this.activeItemId = null
          this.activeTextid = null
        }
      }
      this.activeItemId = null
      this.activeTextid = null
    },

    getAdvertiserList() {
      this.loading = true
      dynamic_creativeindex(this.advertisersQuery).then(res => {
        console.log('res:', res)
        this.tableData = res.data.list
        this.total = res.data.count
        // for (let i = 0; i < res.data.list.length; i++) {
        //   this.accountIdsQuery[i] = res.data.list[i].account_id
        // }
        this.loading = false
        console.log(22)
        // res.data.list.length > 0 && this.getBalanceData()
        // this.tableData[0].advertiser_relation[0].is_master = 1
      })
    },
    getURLData(item) {
      this.dialogVisible = true
      if (item === '微信') {
        getURL().then(res => {
          window.open(res.data.advertiser)
        })
      } else {
        this.typeValue = 'QQ'
        this.$refs.codeScanning.open()
      }
    },
    // 获取用户余额
    getBalanceData() {
      this.moneyLoading = true
      console.log('过来了')
      getBalance({ account_ids: this.accountIdsQuery.toString() }).then(res => {
        const arr = []
        for (let i = 0; i < res.data.length; i++) {
          arr[i] = res.data[i].account
        }
        for (let i = 0; i < this.tableData.length; i++) {
          const index = arr.indexOf(this.tableData[i].account_id)
          if (index !== -1) {
            this.tableData[i].money = res.data[index].balance
          }
        }
        this.accountIdsQuery = []
        this.moneyLoading = false
      })
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.authorizeURLData = null
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.advertisersQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.advertisersQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.advertisersQuery.page = 1
      this.advertisersQuery.page_size = 10
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.advertisersQuery = {}
      this.getAdvertiserList()
    },
    handleCommand(command, data) {
      switch (command) {
        case 'dataReport':
          this.$router.push({
            name: 'EffectData',
            params: { account_id: data.account_id, account_name: data.account_name }
          })
          break
      }
    },
    async openedEnd(callback) {
      let src = null
      try {
        if (this.typeValue === 'MP扫码登录') {
          const data = await getQrCode({
            cancelToken: new axios.CancelToken(c => {
              this.source = c
            })
          })
          src = data.data.data
        } else if (this.typeValue === 'QQ') {
          const data = await qqShouQuan({
            cancelToken: new axios.CancelToken(c => {
              this.source = c
            })
          })
          src = data.data.data
        } else if (this.typeValue === '同步备注') {
          const data = await syncNotes({
            cancelToken: new axios.CancelToken(c => {
              this.source = c
            })
          })
          src = data.data.data
        } else if (this.typeValue === 'ADQ扫码登录') {
          const data = await adqShouQuan({
            cancelToken: new axios.CancelToken(c => {
              this.source = c
            })
          })
          src = data.data.data
        }
        ronyu(src)
      } catch (err) {
        this.source && this.source()
        callback('err')
      }

      function ronyu(src) {
        const img = new Image()
        const src1 = 'data:image/png;base64,' + src
        img.src = src1
        img.onload = () => {
          callback(src1)
        }
      }
    },
    reset(callback) {
      callback()
      this.source && this.source()
    },

    // 清除
    eliminate() {
      this.$confirm('你确定是否清除账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await eliminate()

        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.getAdvertiserList()
      }) /* .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      }) */
    },
    addadvr() {
      this.dialogVisibleadr = true
      this.$nextTick(() => {
        this.$refs.addadview.send()
      })
    },
    updata() {
      this.dialogVisibleadr = false
      this.getAdvertiserList()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 120px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
